var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[(!_vm.hasError)?_c('div',[_c('van-col',{staticStyle:{"text-align":"center"},attrs:{"span":24}},[_vm._v("\n      票据管理\n    ")])],1):_c('div',[_c('span',{staticStyle:{"font-size":"16px","font-weight":"bold","color":"#ff4949"}},[_vm._v(_vm._s(_vm.errorMsg))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b13e6e30","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elecnotes/manage.vue
// module id = null
// module chunks = 